import { createContext, useContext, PropsWithChildren } from 'react';
import { AvailableRoute } from '../types';

type IsRouteAvailableFn = (pathname: string) => boolean;

type RouteAccessContextValue = {
  isRouteAvailable: IsRouteAvailableFn;
  availableRoutes?: AvailableRoute[];
  enableAccessControl?: boolean;
};

const defaultValue: RouteAccessContextValue = {
  isRouteAvailable: () => true,
  availableRoutes: [],
  enableAccessControl: false,
};

const RouteAccessContext = createContext<RouteAccessContextValue>(defaultValue);

interface RouteAccessContextProviderProps
  extends PropsWithChildren,
    RouteAccessContextValue {}

export const RouteAccessContextProvider = ({
  children,
  enableAccessControl = false,
  isRouteAvailable,
  availableRoutes,
}: RouteAccessContextProviderProps) => (
  <RouteAccessContext.Provider
    value={{ isRouteAvailable, availableRoutes, enableAccessControl }}
  >
    {children}
  </RouteAccessContext.Provider>
);

export const useRouteAccessContext = () => {
  const context = useContext(RouteAccessContext);

  if (!context) return defaultValue;

  return context;
};
